import { Plus } from "lucide-react";

export const CategoryList = ({ categories, activeId, onSelect, onAdd }) => (
  <aside
    data-testid="menu-admin-category-list"
    className="bg-[#f0ebe1] border border-[#2c3528]/15 p-4 md:p-5 h-fit"
  >
    <div className="flex items-center justify-between gap-4 mb-4">
      <p data-testid="category-list-title" className="overline text-[#5b7053]">
        Sections
      </p>
      <button
        type="button"
        data-testid="admin-add-category-button"
        onClick={onAdd}
        className="lift h-9 w-9 grid place-items-center bg-[#5b7053] text-[#f9f6f0] hover:bg-[#3f4f39]"
        aria-label="Add menu section"
      >
        <Plus className="h-4 w-4" strokeWidth={1.7} />
      </button>
    </div>

    <div className="space-y-2 max-h-[65vh] overflow-y-auto pr-1">
      {categories.map((category, index) => (
        <button
          key={category.id}
          type="button"
          data-testid={`admin-category-button-${category.id}`}
          onClick={() => onSelect(category.id)}
          className={`w-full text-left px-4 py-3 border transition-colors ${
            activeId === category.id
              ? "bg-[#2c3528] border-[#2c3528] text-[#f9f6f0]"
              : "bg-[#f9f6f0] border-[#2c3528]/10 text-[#2c3528] hover:border-[#5b7053]"
          }`}
        >
          <span data-testid={`admin-category-index-${category.id}`} className="text-xs opacity-70">
            {String(index + 1).padStart(2, "0")}
          </span>
          <span
            data-testid={`admin-category-name-${category.id}`}
            className="block mt-1 font-serif-display text-xl leading-tight"
          >
            {category.name || "Untitled section"}
          </span>
          <span data-testid={`admin-category-item-count-${category.id}`} className="block mt-1 text-xs opacity-70">
            {(category.items || []).length} items
          </span>
        </button>
      ))}
    </div>
  </aside>
);